let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3VAwD")).then(() => parcelRequire('iCdWW'));